import { useEffect, useRef } from "react";

const VIDEO_SRC = "https://customer-assets.emergentagent.com/job_frame-work-9/artifacts/lwkmwasd_Assembly.mp4";

  export default function Hero({ onNav }) {
  const ref = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const nodes = ref.current?.querySelectorAll(".reveal") || [];
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && e.target.classList.add("in"));
    }, { threshold: 0.15 });
    nodes.forEach((n) => io.observe(n));
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    const playVideo = () => {
      video.play().catch(() => {
        // Mobile browsers may still block autoplay until first touch.
      });
    };

    playVideo();

    window.addEventListener("touchstart", playVideo, { once: true });
    window.addEventListener("click", playVideo, { once: true });

    return () => {
      window.removeEventListener("touchstart", playVideo);
      window.removeEventListener("click", playVideo);
    };
  }, []);

  return (
    <section
      ref={ref}
      id="hero"
      data-testid="hero-section"
      className="relative grain hero-section"
      style={{ minHeight: "100vh", paddingTop: 140, paddingBottom: 80, background: "#1a1814", overflow: "hidden" }}
    >
      {/* Looping background video at 70% opacity */}
      <video
      ref={videoRef}
        data-testid="hero-bg-video"
        src={VIDEO_SRC}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.7,
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Subtle dark veil for readability — keeps type crisp without crushing the video */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(20,18,15,0.25) 0%, rgba(20,18,15,0.05) 40%, rgba(20,18,15,0.35) 100%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      <div className="relative mx-auto hero-container" style={{ maxWidth: 1440, padding: "0 40px", zIndex: 2 }}>
        <h1
          data-testid="hero-headline"
          className="font-serif reveal delay-1 hero-headline"
          style={{
            margin: "64px 0 0",
            fontSize: "clamp(56px, 10vw, 140px)",
            lineHeight: 0.92,
            letterSpacing: "-0.025em",
            color: "#F4EFE4",
            maxWidth: 1300,
            textShadow: "0 1px 40px rgba(0,0,0,0.25)",
          }}
        >
          Give us an ad that works.
          <br />
          <em
            style={{
              fontStyle: "italic",
              display: "block",
              color: "rgba(244,239,228,0.55)",
              marginTop: 8,
            }}
          >
            We'll give you 20 that work harder.
          </em>
        </h1>

        <div className="reveal delay-2 hero-cta-row" style={{ marginTop: 56, display: "block" }}>
          <p
            data-testid="hero-sub"
            style={{
              maxWidth: 560,
              fontSize: 17,
              lineHeight: 1.55,
              color: "rgba(244,239,228,0.78)",
              margin: 0,
            }}
          >
            Your best footage, made to travel further.
          </p>
        </div>

        <div
          className="reveal delay-3 hero-meta"
          style={{
            marginTop: 96,
            paddingTop: 18,
            borderTop: "1px solid rgba(244,239,228,0.18)",
            display: "flex",
            justifyContent: "flex-end",
            color: "rgba(244,239,228,0.7)",
          }}
        >
          <span className="font-mono" style={{ fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase" }}>Scroll ↓</span>
        </div>
      </div>
    </section>
  );
}
